import Axios from 'axios'
import env from './env'
import { Toast, Dialog } from 'vant';
import Lanmao from "../../components/lanmao/index"
import { toLink } from '../utils/router.js'
let obj = {};
env.SHOW_LOADING_REQUEST_LIST.forEach((value, index) => {
    obj[value] = true;
})



// 二次封装axios
const service = Axios.create({
    // 设置接口基地址
    baseURL: env.prod.baseUrl,
    timeout: 30000,
})
let ShowLoadingRequestList = obj;

// 添加请求拦截器
service.interceptors.request.use(function (config) {

    // console.log('请求拦截器', config)
    //如果url不等login即登录模块，则要获取本地token，配置header头
    const token = localStorage.getItem('tokens');
    const workNo = localStorage.getItem('workNo');
    if (token) {
        config.headers['thirdSession'] = token
        config.headers['workNo'] = workNo
    }

    if (ShowLoadingRequestList[config.url]) {
        Lanmao.loading.show('加载中...');
    }


    // 在发送请求之前做些什么
    return config
}, function (error) {
    // 对请求错误做些什么
    Toast({
        message: '系统更新中，请稍后重试...',
        position: 'bottom',
    });
    return Promise.resolve(error)
})

// 添加响应拦截器
service.interceptors.response.use(function (res) {
    console.log('返回数据:', res)
    if (res.status == 200) {
        if (ShowLoadingRequestList[res.config.url]) {
            Lanmao.loading.hide();
        }
        console.log('接口状态码：', '【' + res.data.code + '】');
        if (res.data.code == 0) {

            return Promise.resolve(res.data)
        } else if (res.data.code == 1) {

            return Promise.resolve(res.data)
        } else if (res.data.code == -100) {
            // Toast({
            //     message: res.data.msg,
            //     position: 'bottom',
            // });
            return Promise.resolve(res.data)
            // 60001：登录过期 60003：账号在另一部手机登录
        } else if (res.data.code == -101 || res.data.code == -102) {
            Dialog.confirm({
                title: "提示",
                message: res.data.msg,
                confirmButtonText: "去登录",
            }).then(() => {
                toLink('PersonalInformation', {});
            }).catch(() => {
                // on cancel
            });
        } else if (res.data.code == 60001 || res.data.code == 60002 || res.data.code == 60003) {
            Toast({
                message: "请关闭当前链接，重新进入进行开卡。",
                position: 'bottom',
            });
        } else if (res.config.url.slice(0, 21) == "/api/gzh/captchaImage") {
            return Promise.resolve(res.data)
        } else {
            //未知错误
            Toast({
                message: res.data.msg,
                position: 'bottom',
            });
            return Promise.resolve(res.data)
        }

    }
}, function (error) {
    if (ShowLoadingRequestList[error.config.url]) {
        Lanmao.loading.hide();
    }
    if (error.response && error.response.status === 405) {
        const url = error.config.url;
        const lastSegment = url.substring(url.lastIndexOf('/') + 1);
        Toast({
            message: `[${lastSegment}]异常`,
            position: 'bottom',
        });
    } else if (error.code === 'ECONNABORTED' && error.message.includes('timeout')) {
        Toast({
            message: '请求超时，请稍后重试...',
            position: 'bottom',
        });
    } else if (error.response && error.response.status === 500) {
        Toast({
            message: '服务器内部错误 (500)，请稍后重试...',
            position: 'bottom',
        });
    } else {
        Toast({
            message: '系统更新中，请稍后重试...',
            position: 'bottom',
        });
    }

    // 对响应错误做点什么
    return Promise.reject(error)
})

export default service